import React, { useState, useMemo } from 'react';
import soundService from '../utils/soundService';

// Comprehensive English to Sinhala dictionary
const dictionary = [
  // Greetings & Common Phrases
  { english: "hello", sinhala: "ආයුබෝවන්", pronunciation: "aa-yoo-boh-vuhn" },
  { english: "hi", sinhala: "හායි", pronunciation: "haa-yee" },
  { english: "goodbye", sinhala: "ගිහින් එන්නම්", pronunciation: "gee-hin ehn-nuhm" },
  { english: "bye", sinhala: "බයි", pronunciation: "bai" },
  { english: "thank you", sinhala: "ස්තූතියි", pronunciation: "sthoo-thee-yee" },
  { english: "thanks", sinhala: "ස්තූතියි", pronunciation: "sthoo-thee-yee" },
  { english: "please", sinhala: "කරුණාකර", pronunciation: "kuh-roo-naa-kuh-ruh" },
  { english: "sorry", sinhala: "සමාවන්න", pronunciation: "suh-maa-vuhn-nuh" },
  { english: "excuse me", sinhala: "සමාවන්න", pronunciation: "suh-maa-vuhn-nuh" },
  { english: "yes", sinhala: "ඔව්", pronunciation: "ohv" },
  { english: "no", sinhala: "නැහැ", pronunciation: "neh-heh" },
  { english: "okay", sinhala: "හරි", pronunciation: "huh-ree" },
  { english: "welcome", sinhala: "ආයුබෝවන්", pronunciation: "aa-yoo-boh-vuhn" },
  { english: "good morning", sinhala: "සුභ උදෑසනක්", pronunciation: "soo-buh oo-deh-suh-nuhk" },
  { english: "good night", sinhala: "සුභ රාත්‍රියක්", pronunciation: "soo-buh raa-three-yuhk" },
  { english: "how are you", sinhala: "කොහොමද?", pronunciation: "koh-hoh-muh-duh" },
  { english: "i am fine", sinhala: "මම හොඳින්", pronunciation: "muh-muh hohn-din" },
  { english: "what is your name", sinhala: "ඔබේ නම මොකද්ද?", pronunciation: "oh-bay nuh-muh moh-kuhd-duh" },
  { english: "my name is", sinhala: "මගේ නම", pronunciation: "muh-gay nuh-muh" },
  
  // Family
  { english: "mother", sinhala: "අම්මා", pronunciation: "uhm-maa" },
  { english: "father", sinhala: "තාත්තා", pronunciation: "thaa-thaa" },
  { english: "sister", sinhala: "අක්කා/නංගි", pronunciation: "uhk-kaa/nuhn-gee" },
  { english: "brother", sinhala: "අයියා/මල්ලි", pronunciation: "uh-yee-yaa/muhl-lee" },
  { english: "grandmother", sinhala: "ආච්චි", pronunciation: "aach-chee" },
  { english: "grandfather", sinhala: "සීයා", pronunciation: "see-yaa" },
  { english: "family", sinhala: "පවුල", pronunciation: "puh-voo-luh" },
  { english: "baby", sinhala: "බබා", pronunciation: "buh-baa" },
  { english: "child", sinhala: "ළමයා", pronunciation: "luh-muh-yaa" },
  { english: "uncle", sinhala: "මාමා", pronunciation: "maa-maa" },
  { english: "aunt", sinhala: "නැන්දා", pronunciation: "nehn-daa" },
  
  // Numbers
  { english: "one", sinhala: "එක", pronunciation: "eh-kuh" },
  { english: "two", sinhala: "දෙක", pronunciation: "deh-kuh" },
  { english: "three", sinhala: "තුන", pronunciation: "thoo-nuh" },
  { english: "four", sinhala: "හතර", pronunciation: "huh-thuh-ruh" },
  { english: "five", sinhala: "පහ", pronunciation: "puh-huh" },
  { english: "six", sinhala: "හය", pronunciation: "huh-yuh" },
  { english: "seven", sinhala: "හත", pronunciation: "huh-thuh" },
  { english: "eight", sinhala: "අට", pronunciation: "uh-tuh" },
  { english: "nine", sinhala: "නවය", pronunciation: "nuh-vuh-yuh" },
  { english: "ten", sinhala: "දහය", pronunciation: "duh-huh-yuh" },
  { english: "hundred", sinhala: "සියය", pronunciation: "see-yuh-yuh" },
  { english: "thousand", sinhala: "දහස", pronunciation: "duh-huh-suh" },
  
  // Colors
  { english: "red", sinhala: "රතු", pronunciation: "ruh-thoo" },
  { english: "blue", sinhala: "නිල්", pronunciation: "nil" },
  { english: "green", sinhala: "කොළ", pronunciation: "koh-luh" },
  { english: "yellow", sinhala: "කහ", pronunciation: "kuh-huh" },
  { english: "white", sinhala: "සුදු", pronunciation: "soo-doo" },
  { english: "black", sinhala: "කළු", pronunciation: "kuh-loo" },
  { english: "orange", sinhala: "තැඹිලි", pronunciation: "them-bee-lee" },
  { english: "pink", sinhala: "රෝස", pronunciation: "roh-suh" },
  { english: "purple", sinhala: "දම්", pronunciation: "duhm" },
  { english: "brown", sinhala: "දුඹුරු", pronunciation: "doom-boo-roo" },
  
  // Animals
  { english: "dog", sinhala: "බල්ලා", pronunciation: "buhl-laa" },
  { english: "cat", sinhala: "පූසා", pronunciation: "poo-saa" },
  { english: "bird", sinhala: "කුරුල්ලා", pronunciation: "koo-rool-laa" },
  { english: "fish", sinhala: "මාළුවා", pronunciation: "maa-loo-vaa" },
  { english: "elephant", sinhala: "අලියා", pronunciation: "uh-lee-yaa" },
  { english: "lion", sinhala: "සිංහයා", pronunciation: "sin-huh-yaa" },
  { english: "monkey", sinhala: "වඳුරා", pronunciation: "vuhn-doo-raa" },
  { english: "cow", sinhala: "හරකා", pronunciation: "huh-ruh-kaa" },
  { english: "horse", sinhala: "අශ්වයා", pronunciation: "uhsh-vuh-yaa" },
  { english: "rabbit", sinhala: "හාවා", pronunciation: "haa-vaa" },
  { english: "snake", sinhala: "සර්පයා", pronunciation: "suhr-puh-yaa" },
  { english: "butterfly", sinhala: "සමනලයා", pronunciation: "suh-muh-nuh-luh-yaa" },
  
  // Food
  { english: "rice", sinhala: "බත්", pronunciation: "buhth" },
  { english: "water", sinhala: "වතුර", pronunciation: "vuh-thoo-ruh" },
  { english: "tea", sinhala: "තේ", pronunciation: "thay" },
  { english: "milk", sinhala: "කිරි", pronunciation: "kee-ree" },
  { english: "bread", sinhala: "පාන්", pronunciation: "paan" },
  { english: "egg", sinhala: "බිත්තර", pronunciation: "bith-thuh-ruh" },
  { english: "fruit", sinhala: "පලතුරු", pronunciation: "puh-luh-thoo-roo" },
  { english: "vegetable", sinhala: "එළවළු", pronunciation: "eh-luh-vuh-loo" },
  { english: "meat", sinhala: "මස්", pronunciation: "muhs" },
  { english: "fish", sinhala: "මාළු", pronunciation: "maa-loo" },
  { english: "curry", sinhala: "කරි", pronunciation: "kuh-ree" },
  { english: "sugar", sinhala: "සීනි", pronunciation: "see-nee" },
  { english: "salt", sinhala: "ලුණු", pronunciation: "loo-noo" },
  
  // Fruits
  { english: "banana", sinhala: "කෙසෙල්", pronunciation: "keh-sehl" },
  { english: "mango", sinhala: "අඹ", pronunciation: "uhm-buh" },
  { english: "apple", sinhala: "ඇපල්", pronunciation: "eh-puhl" },
  { english: "orange", sinhala: "දොඩම්", pronunciation: "doh-duhm" },
  { english: "coconut", sinhala: "පොල්", pronunciation: "pohl" },
  { english: "papaya", sinhala: "පැපොල්", pronunciation: "peh-pohl" },
  { english: "pineapple", sinhala: "අන්නාසි", pronunciation: "uhn-naa-see" },
  
  // Body Parts
  { english: "head", sinhala: "හිස", pronunciation: "hee-suh" },
  { english: "eye", sinhala: "ඇස", pronunciation: "eh-suh" },
  { english: "ear", sinhala: "කන", pronunciation: "kuh-nuh" },
  { english: "nose", sinhala: "නාසය", pronunciation: "naa-suh-yuh" },
  { english: "mouth", sinhala: "කට", pronunciation: "kuh-tuh" },
  { english: "hand", sinhala: "අත", pronunciation: "uh-thuh" },
  { english: "foot", sinhala: "පාදය", pronunciation: "paa-duh-yuh" },
  { english: "leg", sinhala: "කකුල", pronunciation: "kuh-koo-luh" },
  { english: "heart", sinhala: "හදවත", pronunciation: "huh-duh-vuh-thuh" },
  { english: "teeth", sinhala: "දත්", pronunciation: "duhth" },
  
  // Places
  { english: "house", sinhala: "ගෙදර", pronunciation: "geh-duh-ruh" },
  { english: "home", sinhala: "නිවස", pronunciation: "nee-vuh-suh" },
  { english: "school", sinhala: "පාසල", pronunciation: "paa-suh-luh" },
  { english: "hospital", sinhala: "රෝහල", pronunciation: "roh-huh-luh" },
  { english: "shop", sinhala: "කඩේ", pronunciation: "kuh-day" },
  { english: "market", sinhala: "පොළ", pronunciation: "poh-luh" },
  { english: "temple", sinhala: "පන්සල", pronunciation: "puhn-suh-luh" },
  { english: "church", sinhala: "පල්ලිය", pronunciation: "puhl-lee-yuh" },
  { english: "mosque", sinhala: "මුස්ලිම් පල්ලිය", pronunciation: "mus-lim puhl-lee-yuh" },
  { english: "bank", sinhala: "බැංකුව", pronunciation: "behn-koo-vuh" },
  { english: "hotel", sinhala: "හෝටලය", pronunciation: "hoh-tuh-luh-yuh" },
  { english: "restaurant", sinhala: "ආපනශාලාව", pronunciation: "aa-puh-nuh-shaa-laa-vuh" },
  { english: "library", sinhala: "පුස්තකාලය", pronunciation: "poos-thuh-kaa-luh-yuh" },
  { english: "office", sinhala: "කාර්යාලය", pronunciation: "kaar-yaa-luh-yuh" },
  { english: "station", sinhala: "ස්ථානය", pronunciation: "sthaa-nuh-yuh" },
  { english: "airport", sinhala: "ගුවන් තොටුපළ", pronunciation: "goo-vuhn thoh-too-puh-luh" },
  
  // Transport
  { english: "car", sinhala: "මෝටර් රථය", pronunciation: "moh-tuhr ruh-thuh-yuh" },
  { english: "bus", sinhala: "බස් රථය", pronunciation: "buhs ruh-thuh-yuh" },
  { english: "train", sinhala: "දුම්රිය", pronunciation: "doom-ree-yuh" },
  { english: "bicycle", sinhala: "බයිසිකලය", pronunciation: "bai-see-kuh-luh-yuh" },
  { english: "motorcycle", sinhala: "යතුරුපැදිය", pronunciation: "yuh-thoo-roo-peh-dee-yuh" },
  { english: "boat", sinhala: "බෝට්ටුව", pronunciation: "boht-too-vuh" },
  { english: "plane", sinhala: "ගුවන් යානය", pronunciation: "goo-vuhn yaa-nuh-yuh" },
  { english: "tuk-tuk", sinhala: "ත්‍රීවීලය", pronunciation: "three-vee-luh-yuh" },
  
  // Weather
  { english: "sun", sinhala: "හිරු", pronunciation: "hee-roo" },
  { english: "rain", sinhala: "වැස්ස", pronunciation: "vehs-suh" },
  { english: "cloud", sinhala: "වලාකුළ", pronunciation: "vuh-laa-koo-luh" },
  { english: "wind", sinhala: "සුළඟ", pronunciation: "soo-luhn-guh" },
  { english: "hot", sinhala: "උණුසුම්", pronunciation: "oo-noo-soom" },
  { english: "cold", sinhala: "සීතල", pronunciation: "see-thuh-luh" },
  { english: "weather", sinhala: "කාලගුණය", pronunciation: "kaa-luh-goo-nuh-yuh" },
  
  // Time
  { english: "today", sinhala: "අද", pronunciation: "uh-duh" },
  { english: "tomorrow", sinhala: "හෙට", pronunciation: "heh-tuh" },
  { english: "yesterday", sinhala: "ඊයේ", pronunciation: "ee-yay" },
  { english: "now", sinhala: "දැන්", pronunciation: "dehn" },
  { english: "morning", sinhala: "උදේ", pronunciation: "oo-day" },
  { english: "afternoon", sinhala: "දවල්", pronunciation: "duh-vuhl" },
  { english: "evening", sinhala: "සවස", pronunciation: "suh-vuh-suh" },
  { english: "night", sinhala: "රාත්‍රිය", pronunciation: "raa-three-yuh" },
  { english: "day", sinhala: "දවස", pronunciation: "duh-vuh-suh" },
  { english: "week", sinhala: "සතිය", pronunciation: "suh-thee-yuh" },
  { english: "month", sinhala: "මාසය", pronunciation: "maa-suh-yuh" },
  { english: "year", sinhala: "අවුරුද්ද", pronunciation: "uh-voo-rood-duh" },
  
  // Days of the Week
  { english: "monday", sinhala: "සඳුදා", pronunciation: "suhn-doo-daa" },
  { english: "tuesday", sinhala: "අඟහරුවාදා", pronunciation: "uhn-guh-huh-roo-vaa-daa" },
  { english: "wednesday", sinhala: "බදාදා", pronunciation: "buh-daa-daa" },
  { english: "thursday", sinhala: "බ්‍රහස්පතින්දා", pronunciation: "bruh-huhs-puh-thin-daa" },
  { english: "friday", sinhala: "සිකුරාදා", pronunciation: "see-koo-raa-daa" },
  { english: "saturday", sinhala: "සෙනසුරාදා", pronunciation: "seh-nuh-soo-raa-daa" },
  { english: "sunday", sinhala: "ඉරිදා", pronunciation: "ee-ree-daa" },
  
  // Actions/Verbs
  { english: "eat", sinhala: "කනවා", pronunciation: "kuh-nuh-vaa" },
  { english: "drink", sinhala: "බොනවා", pronunciation: "boh-nuh-vaa" },
  { english: "sleep", sinhala: "නිදාගන්නවා", pronunciation: "nee-daa-guhn-nuh-vaa" },
  { english: "walk", sinhala: "යනවා", pronunciation: "yuh-nuh-vaa" },
  { english: "run", sinhala: "දුවනවා", pronunciation: "doo-vuh-nuh-vaa" },
  { english: "read", sinhala: "කියවනවා", pronunciation: "kee-yuh-vuh-nuh-vaa" },
  { english: "write", sinhala: "ලියනවා", pronunciation: "lee-yuh-nuh-vaa" },
  { english: "speak", sinhala: "කතා කරනවා", pronunciation: "kuh-thaa kuh-ruh-nuh-vaa" },
  { english: "listen", sinhala: "අහනවා", pronunciation: "uh-huh-nuh-vaa" },
  { english: "see", sinhala: "බලනවා", pronunciation: "buh-luh-nuh-vaa" },
  { english: "come", sinhala: "එනවා", pronunciation: "eh-nuh-vaa" },
  { english: "go", sinhala: "යනවා", pronunciation: "yuh-nuh-vaa" },
  { english: "sit", sinhala: "වාඩි වෙනවා", pronunciation: "vaa-dee veh-nuh-vaa" },
  { english: "stand", sinhala: "නැගිටිනවා", pronunciation: "neh-gee-tee-nuh-vaa" },
  { english: "play", sinhala: "සෙල්ලම් කරනවා", pronunciation: "sehl-luhm kuh-ruh-nuh-vaa" },
  { english: "work", sinhala: "වැඩ කරනවා", pronunciation: "veh-duh kuh-ruh-nuh-vaa" },
  { english: "study", sinhala: "ඉගෙන ගන්නවා", pronunciation: "ee-geh-nuh guhn-nuh-vaa" },
  { english: "help", sinhala: "උදව් කරනවා", pronunciation: "oo-duhv kuh-ruh-nuh-vaa" },
  { english: "buy", sinhala: "ගන්නවා", pronunciation: "guhn-nuh-vaa" },
  { english: "sell", sinhala: "විකුණනවා", pronunciation: "vee-koo-nuh-nuh-vaa" },
  
  // Adjectives
  { english: "big", sinhala: "ලොකු", pronunciation: "loh-koo" },
  { english: "small", sinhala: "පොඩි", pronunciation: "poh-dee" },
  { english: "good", sinhala: "හොඳ", pronunciation: "hohn-duh" },
  { english: "bad", sinhala: "නරක", pronunciation: "nuh-ruh-kuh" },
  { english: "beautiful", sinhala: "ලස්සන", pronunciation: "luhs-suh-nuh" },
  { english: "happy", sinhala: "සතුටු", pronunciation: "suh-thoo-too" },
  { english: "sad", sinhala: "දුකට", pronunciation: "doo-kuh-tuh" },
  { english: "new", sinhala: "අලුත්", pronunciation: "uh-looth" },
  { english: "old", sinhala: "පරණ", pronunciation: "puh-ruh-nuh" },
  { english: "fast", sinhala: "වේගවත්", pronunciation: "vay-guh-vuhth" },
  { english: "slow", sinhala: "සෙමින්", pronunciation: "seh-min" },
  { english: "easy", sinhala: "පහසු", pronunciation: "puh-huh-soo" },
  { english: "difficult", sinhala: "අමාරු", pronunciation: "uh-maa-roo" },
  { english: "expensive", sinhala: "මිල අධික", pronunciation: "mee-luh uh-dhee-kuh" },
  { english: "cheap", sinhala: "ලාභ", pronunciation: "laa-buh" },
  
  // Questions
  { english: "what", sinhala: "මොකද්ද", pronunciation: "moh-kuhd-duh" },
  { english: "where", sinhala: "කොහේද", pronunciation: "koh-hay-duh" },
  { english: "when", sinhala: "කවදාද", pronunciation: "kuh-vuh-daa-duh" },
  { english: "who", sinhala: "කවුද", pronunciation: "kuh-voo-duh" },
  { english: "why", sinhala: "ඇයි", pronunciation: "eh-yee" },
  { english: "how", sinhala: "කොහොමද", pronunciation: "koh-hoh-muh-duh" },
  { english: "how much", sinhala: "කීයද", pronunciation: "kee-yuh-duh" },
  { english: "how many", sinhala: "කීයක්ද", pronunciation: "kee-yuhk-duh" },
  
  // Directions
  { english: "left", sinhala: "වම", pronunciation: "vuh-muh" },
  { english: "right", sinhala: "දකුණ", pronunciation: "duh-koo-nuh" },
  { english: "straight", sinhala: "කෙලින්ම", pronunciation: "keh-lin-muh" },
  { english: "up", sinhala: "ඉහළට", pronunciation: "ee-huh-luh-tuh" },
  { english: "down", sinhala: "පහළට", pronunciation: "puh-huh-luh-tuh" },
  { english: "near", sinhala: "ළඟ", pronunciation: "luh-nguh" },
  { english: "far", sinhala: "දුර", pronunciation: "doo-ruh" },
  
  // Professions
  { english: "teacher", sinhala: "ගුරුවරයා", pronunciation: "goo-roo-vuh-ruh-yaa" },
  { english: "doctor", sinhala: "වෛද්‍යවරයා", pronunciation: "vaid-yuh-vuh-ruh-yaa" },
  { english: "nurse", sinhala: "හෙදිය", pronunciation: "heh-dee-yuh" },
  { english: "police", sinhala: "පොලිස්කාරයා", pronunciation: "poh-lis-kaa-ruh-yaa" },
  { english: "farmer", sinhala: "ගොවියා", pronunciation: "goh-vee-yaa" },
  { english: "driver", sinhala: "රියදුරා", pronunciation: "ree-yuh-doo-raa" },
  { english: "student", sinhala: "සිසුවා", pronunciation: "see-soo-vaa" },
  
  // Clothing
  { english: "shirt", sinhala: "කමිසය", pronunciation: "kuh-mee-suh-yuh" },
  { english: "pants", sinhala: "කලිසම", pronunciation: "kuh-lee-suh-muh" },
  { english: "dress", sinhala: "ගවුම", pronunciation: "guh-voo-muh" },
  { english: "shoes", sinhala: "සපත්තු", pronunciation: "suh-puhth-thoo" },
  { english: "hat", sinhala: "තොප්පිය", pronunciation: "thohp-pee-yuh" },
  
  // Emergency & Travel
  { english: "help", sinhala: "උදව්", pronunciation: "oo-duhv" },
  { english: "police", sinhala: "පොලිසිය", pronunciation: "poh-lee-see-yuh" },
  { english: "hospital", sinhala: "රෝහල", pronunciation: "roh-huh-luh" },
  { english: "sick", sinhala: "අසනීප", pronunciation: "uh-suh-nee-puh" },
  { english: "lost", sinhala: "මග හැරුණා", pronunciation: "muh-guh heh-roo-naa" },
  { english: "ticket", sinhala: "ටිකට්", pronunciation: "tee-kuht" },
  { english: "passport", sinhala: "ගමන් බලපත්‍රය", pronunciation: "guh-muhn buh-luh-puh-thruh-yuh" },
  
  // Technology
  { english: "computer", sinhala: "පරිගණකය", pronunciation: "puh-ree-guh-nuh-kuh-yuh" },
  { english: "laptop", sinhala: "ලැප්ටොප්", pronunciation: "lehp-tohp" },
  { english: "internet", sinhala: "අන්තර්ජාලය", pronunciation: "uhn-thuhr-jaa-luh-yuh" },
  { english: "email", sinhala: "විද්‍යුත් තැපෑල", pronunciation: "vid-yooth theh-peh-luh" },
  { english: "website", sinhala: "වෙබ් අඩවිය", pronunciation: "vehb uh-duh-vee-yuh" },
  { english: "password", sinhala: "මුරපදය", pronunciation: "moo-ruh-puh-duh-yuh" },
  { english: "keyboard", sinhala: "යතුරු පුවරුව", pronunciation: "yuh-thoo-roo poo-vuh-roo-vuh" },
  { english: "mouse", sinhala: "මවුසය", pronunciation: "mau-suh-yuh" },
  { english: "screen", sinhala: "තිරය", pronunciation: "thee-ruh-yuh" },
  { english: "printer", sinhala: "මුද්‍රණ යන්ත්‍රය", pronunciation: "mood-ruh-nuh yuhn-thruh-yuh" },
  { english: "camera", sinhala: "කැමරාව", pronunciation: "keh-muh-raa-vuh" },
  { english: "television", sinhala: "රූපවාහිනිය", pronunciation: "roo-puh-vaa-hee-nee-yuh" },
  { english: "radio", sinhala: "ගුවන් විදුලිය", pronunciation: "goo-vuhn vee-doo-lee-yuh" },
  { english: "mobile", sinhala: "ජංගම දුරකථනය", pronunciation: "juhn-guh-muh doo-ruh-kuh-thuh-nuh-yuh" },
  
  // Common objects
  { english: "book", sinhala: "පොත", pronunciation: "poh-thuh" },
  { english: "pen", sinhala: "පෑන", pronunciation: "peh-nuh" },
  { english: "phone", sinhala: "දුරකථනය", pronunciation: "doo-ruh-kuh-thuh-nuh-yuh" },
  { english: "money", sinhala: "සල්ලි", pronunciation: "suhl-lee" },
  { english: "key", sinhala: "යතුර", pronunciation: "yuh-thoo-ruh" },
  { english: "door", sinhala: "දොර", pronunciation: "doh-ruh" },
  { english: "window", sinhala: "ජනේලය", pronunciation: "juh-nay-luh-yuh" },
  { english: "table", sinhala: "මේසය", pronunciation: "may-suh-yuh" },
  { english: "chair", sinhala: "පුටුව", pronunciation: "poo-too-vuh" },
  { english: "bed", sinhala: "ඇඳ", pronunciation: "ehn-duh" },
  
  // Nature
  { english: "tree", sinhala: "ගස", pronunciation: "guh-suh" },
  { english: "flower", sinhala: "මල", pronunciation: "muh-luh" },
  { english: "river", sinhala: "ගඟ", pronunciation: "guhn-guh" },
  { english: "sea", sinhala: "මුහුද", pronunciation: "moo-hoo-duh" },
  { english: "mountain", sinhala: "කන්ද", pronunciation: "kuhn-duh" },
  { english: "sky", sinhala: "අහස", pronunciation: "uh-huh-suh" },
  { english: "star", sinhala: "තරුව", pronunciation: "thuh-roo-vuh" },
  { english: "moon", sinhala: "හඳ", pronunciation: "huhn-duh" },
  { english: "earth", sinhala: "පොළොව", pronunciation: "poh-loh-vuh" },
  { english: "world", sinhala: "ලෝකය", pronunciation: "loh-kuh-yuh" },
  { english: "forest", sinhala: "වනය", pronunciation: "vuh-nuh-yuh" },
  { english: "garden", sinhala: "වත්ත", pronunciation: "vuhth-thuh" },
  { english: "grass", sinhala: "තණකොළ", pronunciation: "thuh-nuh-koh-luh" },
  { english: "leaf", sinhala: "කොළය", pronunciation: "koh-luh-yuh" },
  { english: "rock", sinhala: "ගල", pronunciation: "guh-luh" },
  { english: "stone", sinhala: "ගල", pronunciation: "guh-luh" },
  { english: "sand", sinhala: "වැලි", pronunciation: "veh-lee" },
  { english: "beach", sinhala: "වෙරළ", pronunciation: "veh-ruh-luh" },
  { english: "ocean", sinhala: "සාගරය", pronunciation: "saa-guh-ruh-yuh" },
  { english: "lake", sinhala: "විල", pronunciation: "vee-luh" },
  { english: "waterfall", sinhala: "දිය ඇල්ල", pronunciation: "dee-yuh ehl-luh" },
  { english: "island", sinhala: "දූපත", pronunciation: "doo-puh-thuh" },
  { english: "hill", sinhala: "කඳු", pronunciation: "kuhn-doo" },
  { english: "field", sinhala: "කෙත", pronunciation: "keh-thuh" },
  { english: "farm", sinhala: "ගොවිපල", pronunciation: "goh-vee-puh-luh" },
  
  // More Animals
  { english: "tiger", sinhala: "කොටියා", pronunciation: "koh-tee-yaa" },
  { english: "bear", sinhala: "වලහා", pronunciation: "vuh-luh-haa" },
  { english: "deer", sinhala: "මුවා", pronunciation: "moo-vaa" },
  { english: "goat", sinhala: "එළුවා", pronunciation: "eh-loo-vaa" },
  { english: "sheep", sinhala: "බැටළුවා", pronunciation: "beh-tuh-loo-vaa" },
  { english: "pig", sinhala: "ඌරා", pronunciation: "oo-raa" },
  { english: "chicken", sinhala: "කුකුළා", pronunciation: "koo-koo-laa" },
  { english: "duck", sinhala: "තාරාවා", pronunciation: "thaa-raa-vaa" },
  { english: "frog", sinhala: "ගෙම්බා", pronunciation: "gehm-baa" },
  { english: "turtle", sinhala: "ඉබ්බා", pronunciation: "eeb-baa" },
  { english: "crocodile", sinhala: "කිඹුලා", pronunciation: "kim-boo-laa" },
  { english: "shark", sinhala: "මෝරා", pronunciation: "moh-raa" },
  { english: "whale", sinhala: "තල්මහා", pronunciation: "thuhl-muh-haa" },
  { english: "dolphin", sinhala: "ඩොල්ෆින්", pronunciation: "dohl-fin" },
  { english: "crab", sinhala: "කකුළුවා", pronunciation: "kuh-koo-loo-vaa" },
  { english: "ant", sinhala: "කුහුඹුවා", pronunciation: "koo-hoom-boo-vaa" },
  { english: "bee", sinhala: "මී මැස්සා", pronunciation: "mee mehs-saa" },
  { english: "mosquito", sinhala: "මදුරුවා", pronunciation: "muh-doo-roo-vaa" },
  { english: "spider", sinhala: "මකුළුවා", pronunciation: "muh-koo-loo-vaa" },
  { english: "parrot", sinhala: "ගිරවා", pronunciation: "gee-ruh-vaa" },
  { english: "crow", sinhala: "කපුටා", pronunciation: "kuh-poo-taa" },
  { english: "peacock", sinhala: "මොණරා", pronunciation: "moh-nuh-raa" },
  { english: "owl", sinhala: "බකමූණා", pronunciation: "buh-kuh-moo-naa" },
  { english: "eagle", sinhala: "රාජාලියා", pronunciation: "raa-jaa-lee-yaa" },
  
  // More Food & Drinks
  { english: "coffee", sinhala: "කෝපි", pronunciation: "koh-pee" },
  { english: "juice", sinhala: "යුෂ", pronunciation: "yoo-shuh" },
  { english: "soup", sinhala: "සුප්", pronunciation: "soop" },
  { english: "cake", sinhala: "කේක්", pronunciation: "kayk" },
  { english: "biscuit", sinhala: "බිස්කට්", pronunciation: "bis-kuht" },
  { english: "chocolate", sinhala: "චොකලට්", pronunciation: "choh-kuh-luht" },
  { english: "ice cream", sinhala: "අයිස්ක්‍රීම්", pronunciation: "ais-kreem" },
  { english: "cheese", sinhala: "චීස්", pronunciation: "chees" },
  { english: "butter", sinhala: "බටර්", pronunciation: "buh-tuhr" },
  { english: "oil", sinhala: "තෙල්", pronunciation: "thehl" },
  { english: "pepper", sinhala: "ගම්මිරිස්", pronunciation: "guhm-mee-ris" },
  { english: "onion", sinhala: "ලූණු", pronunciation: "loo-noo" },
  { english: "garlic", sinhala: "සුදුළූණු", pronunciation: "soo-doo-loo-noo" },
  { english: "ginger", sinhala: "ඉඟුරු", pronunciation: "in-goo-roo" },
  { english: "tomato", sinhala: "තක්කාලි", pronunciation: "thuhk-kaa-lee" },
  { english: "potato", sinhala: "අල", pronunciation: "uh-luh" },
  { english: "carrot", sinhala: "කැරට්", pronunciation: "keh-ruht" },
  { english: "cabbage", sinhala: "ගෝවා", pronunciation: "goh-vaa" },
  { english: "beans", sinhala: "බෝංචි", pronunciation: "bohn-chee" },
  { english: "corn", sinhala: "බඩ ඉරිඟු", pronunciation: "buh-duh ee-rin-goo" },
  { english: "mushroom", sinhala: "හතු", pronunciation: "huh-thoo" },
  { english: "lemon", sinhala: "දෙහි", pronunciation: "deh-hee" },
  { english: "grape", sinhala: "මිදි", pronunciation: "mee-dee" },
  { english: "watermelon", sinhala: "කොමඩු", pronunciation: "koh-muh-doo" },
  { english: "jackfruit", sinhala: "කොස්", pronunciation: "kohs" },
  
  // More Body Parts
  { english: "face", sinhala: "මුහුණ", pronunciation: "moo-hoo-nuh" },
  { english: "hair", sinhala: "කෙස්", pronunciation: "kehs" },
  { english: "neck", sinhala: "බෙල්ල", pronunciation: "behl-luh" },
  { english: "shoulder", sinhala: "උරහිස", pronunciation: "oo-ruh-hee-suh" },
  { english: "arm", sinhala: "අත", pronunciation: "uh-thuh" },
  { english: "finger", sinhala: "ඇඟිල්ල", pronunciation: "ehn-geel-luh" },
  { english: "thumb", sinhala: "මාපට ඇඟිල්ල", pronunciation: "maa-puh-tuh ehn-geel-luh" },
  { english: "chest", sinhala: "පපුව", pronunciation: "puh-poo-vuh" },
  { english: "stomach", sinhala: "බඩ", pronunciation: "buh-duh" },
  { english: "back", sinhala: "පිට", pronunciation: "pee-tuh" },
  { english: "knee", sinhala: "දණහිස", pronunciation: "duh-nuh-hee-suh" },
  { english: "toe", sinhala: "පා ඇඟිල්ල", pronunciation: "paa ehn-geel-luh" },
  { english: "skin", sinhala: "සම", pronunciation: "suh-muh" },
  { english: "bone", sinhala: "ඇට", pronunciation: "eh-tuh" },
  { english: "blood", sinhala: "ලේ", pronunciation: "lay" },
  { english: "brain", sinhala: "මොළය", pronunciation: "moh-luh-yuh" },
  { english: "tongue", sinhala: "දිව", pronunciation: "dee-vuh" },
  
  // More Places
  { english: "city", sinhala: "නගරය", pronunciation: "nuh-guh-ruh-yuh" },
  { english: "village", sinhala: "ගම", pronunciation: "guh-muh" },
  { english: "country", sinhala: "රට", pronunciation: "ruh-tuh" },
  { english: "street", sinhala: "වීදිය", pronunciation: "vee-dee-yuh" },
  { english: "road", sinhala: "පාර", pronunciation: "paa-ruh" },
  { english: "bridge", sinhala: "පාලම", pronunciation: "paa-luh-muh" },
  { english: "park", sinhala: "උද්‍යානය", pronunciation: "ood-yaa-nuh-yuh" },
  { english: "zoo", sinhala: "සත්ව උද්‍යානය", pronunciation: "suhth-vuh ood-yaa-nuh-yuh" },
  { english: "museum", sinhala: "කෞතුකාගාරය", pronunciation: "kau-thoo-kaa-gaa-ruh-yuh" },
  { english: "cinema", sinhala: "සිනමා ශාලාව", pronunciation: "see-nuh-maa shaa-laa-vuh" },
  { english: "stadium", sinhala: "ක්‍රීඩාංගණය", pronunciation: "kree-daan-guh-nuh-yuh" },
  { english: "gym", sinhala: "ව්‍යායාම ශාලාව", pronunciation: "vyaa-yaa-muh shaa-laa-vuh" },
  { english: "supermarket", sinhala: "සුපිරි වෙළඳසැල", pronunciation: "soo-pee-ree veh-luhn-duh-seh-luh" },
  { english: "pharmacy", sinhala: "ෆාමසිය", pronunciation: "faa-muh-see-yuh" },
  { english: "bakery", sinhala: "බේකරිය", pronunciation: "bay-kuh-ree-yuh" },
  { english: "university", sinhala: "විශ්වවිද්‍යාලය", pronunciation: "vish-vuh-vid-yaa-luh-yuh" },
  { english: "college", sinhala: "විද්‍යාලය", pronunciation: "vid-yaa-luh-yuh" },
  { english: "post office", sinhala: "තැපැල් කාර්යාලය", pronunciation: "theh-pehl kaar-yaa-luh-yuh" },
  { english: "police station", sinhala: "පොලිස් ස්ථානය", pronunciation: "poh-lis sthaa-nuh-yuh" },
  
  // More Professions
  { english: "engineer", sinhala: "ඉංජිනේරු", pronunciation: "in-jee-nay-roo" },
  { english: "lawyer", sinhala: "නීතිඥයා", pronunciation: "nee-theeg-nuh-yaa" },
  { english: "scientist", sinhala: "විද්‍යාඥයා", pronunciation: "vid-yaag-nuh-yaa" },
  { english: "artist", sinhala: "කලාකරුවා", pronunciation: "kuh-laa-kuh-roo-vaa" },
  { english: "musician", sinhala: "සංගීතඥයා", pronunciation: "suhn-gee-thuhg-nuh-yaa" },
  { english: "singer", sinhala: "ගායකයා", pronunciation: "gaa-yuh-kuh-yaa" },
  { english: "dancer", sinhala: "නර්තකයා", pronunciation: "nuhr-thuh-kuh-yaa" },
  { english: "actor", sinhala: "නළුවා", pronunciation: "nuh-loo-vaa" },
  { english: "actress", sinhala: "නිළිය", pronunciation: "nee-lee-yuh" },
  { english: "writer", sinhala: "ලේඛකයා", pronunciation: "lay-khuh-kuh-yaa" },
  { english: "chef", sinhala: "පිසින්නා", pronunciation: "pee-sin-naa" },
  { english: "waiter", sinhala: "වේටර්", pronunciation: "vay-tuhr" },
  { english: "pilot", sinhala: "ගුවන් නියමුවා", pronunciation: "goo-vuhn nee-yuh-moo-vaa" },
  { english: "soldier", sinhala: "සොල්දාදුවා", pronunciation: "sohl-daa-doo-vaa" },
  { english: "dentist", sinhala: "දන්ත වෛද්‍යවරයා", pronunciation: "duhn-thuh vaid-yuh-vuh-ruh-yaa" },
  { english: "mechanic", sinhala: "කාර්මිකයා", pronunciation: "kaar-mee-kuh-yaa" },
  { english: "carpenter", sinhala: "වඩුවා", pronunciation: "vuh-doo-vaa" },
  { english: "tailor", sinhala: "මහන්නා", pronunciation: "muh-huhn-naa" },
  { english: "barber", sinhala: "කොණ්ඩකාරයා", pronunciation: "kohn-duh-kaa-ruh-yaa" },
  { english: "fisherman", sinhala: "ධීවරයා", pronunciation: "dhee-vuh-ruh-yaa" },
  { english: "manager", sinhala: "කළමනාකරු", pronunciation: "kuh-luh-muh-naa-kuh-roo" },
  
  // More Verbs
  { english: "think", sinhala: "හිතනවා", pronunciation: "hee-thuh-nuh-vaa" },
  { english: "know", sinhala: "දන්නවා", pronunciation: "duhn-nuh-vaa" },
  { english: "understand", sinhala: "තේරෙනවා", pronunciation: "thay-reh-nuh-vaa" },
  { english: "remember", sinhala: "මතක් වෙනවා", pronunciation: "muh-thuhk veh-nuh-vaa" },
  { english: "forget", sinhala: "අමතක වෙනවා", pronunciation: "uh-muh-thuhk veh-nuh-vaa" },
  { english: "teach", sinhala: "උගන්වනවා", pronunciation: "oo-guhn-vuh-nuh-vaa" },
  { english: "ask", sinhala: "අහනවා", pronunciation: "uh-huh-nuh-vaa" },
  { english: "answer", sinhala: "උත්තර දෙනවා", pronunciation: "ooth-thuh-ruh deh-nuh-vaa" },
  { english: "say", sinhala: "කියනවා", pronunciation: "kee-yuh-nuh-vaa" },
  { english: "tell", sinhala: "කියනවා", pronunciation: "kee-yuh-nuh-vaa" },
  { english: "call", sinhala: "කතා කරනවා", pronunciation: "kuh-thaa kuh-ruh-nuh-vaa" },
  { english: "sing", sinhala: "ගයනවා", pronunciation: "guh-yuh-nuh-vaa" },
  { english: "dance", sinhala: "නටනවා", pronunciation: "nuh-tuh-nuh-vaa" },
  { english: "laugh", sinhala: "හිනා වෙනවා", pronunciation: "hee-naa veh-nuh-vaa" },
  { english: "cry", sinhala: "අඬනවා", pronunciation: "uhn-duh-nuh-vaa" },
  { english: "smile", sinhala: "සිනාසෙනවා", pronunciation: "see-naa-seh-nuh-vaa" },
  { english: "love", sinhala: "ආදරය කරනවා", pronunciation: "aa-duh-ruh-yuh kuh-ruh-nuh-vaa" },
  { english: "like", sinhala: "කැමතියි", pronunciation: "keh-muh-thee-yee" },
  { english: "want", sinhala: "ඕනේ", pronunciation: "oh-nay" },
  { english: "need", sinhala: "ඕනේ", pronunciation: "oh-nay" },
  { english: "have", sinhala: "තියෙනවා", pronunciation: "thee-yeh-nuh-vaa" },
  { english: "give", sinhala: "දෙනවා", pronunciation: "deh-nuh-vaa" },
  { english: "take", sinhala: "ගන්නවා", pronunciation: "guhn-nuh-vaa" },
  { english: "bring", sinhala: "ගේනවා", pronunciation: "gay-nuh-vaa" },
  { english: "send", sinhala: "යවනවා", pronunciation: "yuh-vuh-nuh-vaa" },
  { english: "open", sinhala: "අරිනවා", pronunciation: "uh-ree-nuh-vaa" },
  { english: "close", sinhala: "වහනවා", pronunciation: "vuh-huh-nuh-vaa" },
  { english: "start", sinhala: "පටන් ගන්නවා", pronunciation: "puh-tuhn guhn-nuh-vaa" },
  { english: "stop", sinhala: "නවත්තනවා", pronunciation: "nuh-vuhth-thuh-nuh-vaa" },
  { english: "finish", sinhala: "ඉවර කරනවා", pronunciation: "ee-vuh-ruh kuh-ruh-nuh-vaa" },
  { english: "wait", sinhala: "ඉන්නවා", pronunciation: "in-nuh-vaa" },
  { english: "leave", sinhala: "යනවා", pronunciation: "yuh-nuh-vaa" },
  { english: "arrive", sinhala: "එනවා", pronunciation: "eh-nuh-vaa" },
  { english: "return", sinhala: "ආපසු එනවා", pronunciation: "aa-puh-soo eh-nuh-vaa" },
  { english: "climb", sinhala: "නගිනවා", pronunciation: "nuh-gee-nuh-vaa" },
  { english: "fall", sinhala: "වැටෙනවා", pronunciation: "veh-teh-nuh-vaa" },
  { english: "jump", sinhala: "පනිනවා", pronunciation: "puh-nee-nuh-vaa" },
  { english: "swim", sinhala: "පිහිනනවා", pronunciation: "pee-hee-nuh-nuh-vaa" },
  { english: "drive", sinhala: "පදවනවා", pronunciation: "puh-duh-vuh-nuh-vaa" },
  { english: "push", sinhala: "තල්ලු කරනවා", pronunciation: "thuhl-loo kuh-ruh-nuh-vaa" },
  { english: "pull", sinhala: "ඇදගන්නවා", pronunciation: "eh-duh-guhn-nuh-vaa" },
  { english: "carry", sinhala: "ගෙනියනවා", pronunciation: "geh-nee-yuh-nuh-vaa" },
  { english: "throw", sinhala: "විසි කරනවා", pronunciation: "vee-see kuh-ruh-nuh-vaa" },
  { english: "catch", sinhala: "අල්ලනවා", pronunciation: "uhl-luh-nuh-vaa" },
  { english: "hit", sinhala: "ගහනවා", pronunciation: "guh-huh-nuh-vaa" },
  { english: "break", sinhala: "කඩනවා", pronunciation: "kuh-duh-nuh-vaa" },
  { english: "fix", sinhala: "හදනවා", pronunciation: "huh-duh-nuh-vaa" },
  { english: "build", sinhala: "හදනවා", pronunciation: "huh-duh-nuh-vaa" },
  { english: "make", sinhala: "හදනවා", pronunciation: "huh-duh-nuh-vaa" },
  { english: "cut", sinhala: "කපනවා", pronunciation: "kuh-puh-nuh-vaa" },
  { english: "wash", sinhala: "සෝදනවා", pronunciation: "soh-duh-nuh-vaa" },
  { english: "clean", sinhala: "පිරිසිදු කරනවා", pronunciation: "pee-ree-see-doo kuh-ruh-nuh-vaa" },
  { english: "pay", sinhala: "ගෙවනවා", pronunciation: "geh-vuh-nuh-vaa" },
  { english: "choose", sinhala: "තෝරනවා", pronunciation: "thoh-ruh-nuh-vaa" },
  { english: "try", sinhala: "උත්සාහ කරනවා", pronunciation: "ooth-saa-huh kuh-ruh-nuh-vaa" },
  { english: "find", sinhala: "හොයනවා", pronunciation: "hoh-yuh-nuh-vaa" },
  { english: "lose", sinhala: "නැති වෙනවා", pronunciation: "neh-thee veh-nuh-vaa" },
  { english: "win", sinhala: "දිනවා", pronunciation: "dee-nuh-vaa" },
  { english: "change", sinhala: "වෙනස් කරනවා", pronunciation: "veh-nuhs kuh-ruh-nuh-vaa" },
  { english: "grow", sinhala: "වැඩෙනවා", pronunciation: "veh-deh-nuh-vaa" },
  { english: "die", sinhala: "මැරෙනවා", pronunciation: "meh-reh-nuh-vaa" },
  { english: "live", sinhala: "ජීවත් වෙනවා", pronunciation: "jee-vuhth veh-nuh-vaa" },
  
  // More Adjectives
  { english: "tall", sinhala: "උස", pronunciation: "oo-suh" },
  { english: "short", sinhala: "මිටි", pronunciation: "mee-tee" },
  { english: "long", sinhala: "දිග", pronunciation: "dee-guh" },
  { english: "wide", sinhala: "පළල", pronunciation: "puh-luh-luh" },
  { english: "thick", sinhala: "ඝන", pronunciation: "ghuh-nuh" },
  { english: "thin", sinhala: "සිහින්", pronunciation: "see-hin" },
  { english: "heavy", sinhala: "බර", pronunciation: "buh-ruh" },
  { english: "light", sinhala: "සැහැල්ලු", pronunciation: "seh-hehl-loo" },
  { english: "hard", sinhala: "තද", pronunciation: "thuh-duh" },
  { english: "soft", sinhala: "මෘදු", pronunciation: "mru-doo" },
  { english: "wet", sinhala: "තෙත්", pronunciation: "thehth" },
  { english: "dirty", sinhala: "අපිරිසිදු", pronunciation: "uh-pee-ree-see-doo" },
  { english: "empty", sinhala: "හිස්", pronunciation: "his" },
  { english: "full", sinhala: "පිරුණු", pronunciation: "pee-roo-noo" },
  { english: "rich", sinhala: "පොහොසත්", pronunciation: "poh-hoh-suhth" },
  { english: "poor", sinhala: "දුප්පත්", pronunciation: "doop-puhth" },
  { english: "young", sinhala: "තරුණ", pronunciation: "thuh-roo-nuh" },
  { english: "strong", sinhala: "ශක්තිමත්", pronunciation: "shuhk-thee-muhth" },
  { english: "weak", sinhala: "දුර්වල", pronunciation: "door-vuh-luh" },
  { english: "healthy", sinhala: "සෞඛ්‍ය සම්පන්න", pronunciation: "sau-khyuh suhm-puhn-nuh" },
  { english: "tired", sinhala: "වෙහෙසුණු", pronunciation: "veh-heh-soo-noo" },
  { english: "hungry", sinhala: "බඩගිනි", pronunciation: "buh-duh-gee-nee" },
  { english: "thirsty", sinhala: "පිපාසය", pronunciation: "pee-paa-suh-yuh" },
  { english: "angry", sinhala: "තරහ", pronunciation: "thuh-ruh-huh" },
  { english: "afraid", sinhala: "බය", pronunciation: "buh-yuh" },
  { english: "surprised", sinhala: "පුදුම", pronunciation: "poo-doo-muh" },
  { english: "excited", sinhala: "උද්යෝගිමත්", pronunciation: "ood-yoh-gee-muhth" },
  { english: "bored", sinhala: "කම්මැලි", pronunciation: "kuhm-meh-lee" },
  { english: "proud", sinhala: "ආඩම්බර", pronunciation: "aa-duhm-buh-ruh" },
  { english: "shy", sinhala: "ලැජ්ජා", pronunciation: "lehj-jaa" },
  { english: "brave", sinhala: "නිර්භීත", pronunciation: "nir-bhee-thuh" },
  { english: "kind", sinhala: "කරුණාවන්ත", pronunciation: "kuh-roo-naa-vuhn-thuh" },
  { english: "honest", sinhala: "අවංක", pronunciation: "uh-vuhn-kuh" },
  { english: "lazy", sinhala: "කම්මැලි", pronunciation: "kuhm-meh-lee" },
  { english: "busy", sinhala: "කාර්යබහුල", pronunciation: "kaar-yuh-buh-hoo-luh" },
  { english: "free", sinhala: "නිදහස්", pronunciation: "nee-duh-huhs" },
  { english: "safe", sinhala: "ආරක්ෂිත", pronunciation: "aa-ruhk-shee-thuh" },
  { english: "dangerous", sinhala: "භයානක", pronunciation: "bhuh-yaa-nuh-kuh" },
  { english: "important", sinhala: "වැදගත්", pronunciation: "veh-duh-guhth" },
  { english: "famous", sinhala: "ප්‍රසිද්ධ", pronunciation: "pruh-sid-dhuh" },
  { english: "special", sinhala: "විශේෂ", pronunciation: "vee-shay-shuh" },
  { english: "different", sinhala: "වෙනස්", pronunciation: "veh-nuhs" },
  { english: "same", sinhala: "එකම", pronunciation: "eh-kuh-muh" },
  { english: "possible", sinhala: "හැකි", pronunciation: "heh-kee" },
  { english: "ready", sinhala: "සූදානම්", pronunciation: "soo-daa-nuhm" },
  { english: "late", sinhala: "පරක්කු", pronunciation: "puh-ruhk-koo" },
  { english: "early", sinhala: "ඉක්මනින්", pronunciation: "ik-muh-nin" },
  { english: "correct", sinhala: "නිවැරදි", pronunciation: "nee-veh-ruh-dee" },
  { english: "wrong", sinhala: "වැරදි", pronunciation: "veh-ruh-dee" },
  { english: "true", sinhala: "සත්‍ය", pronunciation: "suhth-yuh" },
  { english: "false", sinhala: "අසත්‍ය", pronunciation: "uh-suhth-yuh" },
  { english: "sweet", sinhala: "පැණි රස", pronunciation: "peh-nee ruh-suh" },
  { english: "sour", sinhala: "ඇඹුල්", pronunciation: "ehm-bool" },
  { english: "bitter", sinhala: "තිත්ත", pronunciation: "theeth-thuh" },
  { english: "spicy", sinhala: "කටු", pronunciation: "kuh-too" },
  { english: "delicious", sinhala: "රසවත්", pronunciation: "ruh-suh-vuhth" },
  { english: "fresh", sinhala: "නැවුම්", pronunciation: "neh-voom" },
  { english: "loud", sinhala: "හයියෙන්", pronunciation: "huh-yee-yehn" },
  { english: "quiet", sinhala: "නිහඬ", pronunciation: "nee-huhn-duh" },
  { english: "bright", sinhala: "දීප්තිමත්", pronunciation: "deep-thee-muhth" },
  { english: "dark", sinhala: "අඳුරු", pronunciation: "uhn-doo-roo" },
  { english: "sharp", sinhala: "තියුණු", pronunciation: "thee-yoo-noo" },
  { english: "smooth", sinhala: "සුමට", pronunciation: "soo-muh-tuh" },
  { english: "rough", sinhala: "රළු", pronunciation: "ruh-loo" },
  { english: "round", sinhala: "රවුම්", pronunciation: "ruh-voom" },
  { english: "deep", sinhala: "ගැඹුරු", pronunciation: "gehm-boo-roo" },
  
  // More Clothing
  { english: "jacket", sinhala: "ජැකට්", pronunciation: "jeh-kuht" },
  { english: "coat", sinhala: "කෝට්", pronunciation: "koht" },
  { english: "sweater", sinhala: "ස්වෙටර්", pronunciation: "sveh-tuhr" },
  { english: "jeans", sinhala: "ජීන්ස්", pronunciation: "jeens" },
  { english: "shorts", sinhala: "කොට කලිසම", pronunciation: "koh-tuh kuh-lee-suh-muh" },
  { english: "skirt", sinhala: "සාය", pronunciation: "saa-yuh" },
  { english: "socks", sinhala: "මේස්", pronunciation: "mays" },
  { english: "tie", sinhala: "ටයි", pronunciation: "tai" },
  { english: "belt", sinhala: "පටිය", pronunciation: "puh-tee-yuh" },
  { english: "gloves", sinhala: "අත්වැසුම්", pronunciation: "uhth-veh-soom" },
  { english: "scarf", sinhala: "ස්කාෆ්", pronunciation: "skaaf" },
  { english: "uniform", sinhala: "නිල ඇඳුම", pronunciation: "nee-luh ehn-doo-muh" },
  { english: "glasses", sinhala: "කණ්ණාඩි", pronunciation: "kuhn-naa-dee" },
  { english: "watch", sinhala: "ඔරලෝසුව", pronunciation: "oh-ruh-loh-soo-vuh" },
  { english: "ring", sinhala: "මුද්ද", pronunciation: "mood-duh" },
  { english: "necklace", sinhala: "මාලය", pronunciation: "maa-luh-yuh" },
  { english: "earring", sinhala: "කරාබු", pronunciation: "kuh-raa-boo" },
  { english: "bracelet", sinhala: "වළල්ල", pronunciation: "vuh-luhl-luh" },
  { english: "purse", sinhala: "මුදල් පසුම්බිය", pronunciation: "moo-duhl puh-soom-bee-yuh" },
  { english: "wallet", sinhala: "පසුම්බිය", pronunciation: "puh-soom-bee-yuh" },
  { english: "umbrella", sinhala: "කුඩය", pronunciation: "koo-duh-yuh" },
  
  // Household Items
  { english: "lamp", sinhala: "ලාම්පුව", pronunciation: "laam-poo-vuh" },
  { english: "fan", sinhala: "පංකාව", pronunciation: "puhn-kaa-vuh" },
  { english: "refrigerator", sinhala: "ශීතකරණය", pronunciation: "shee-thuh-kuh-ruh-nuh-yuh" },
  { english: "fridge", sinhala: "ශීතකරණය", pronunciation: "shee-thuh-kuh-ruh-nuh-yuh" },
  { english: "stove", sinhala: "උදුන", pronunciation: "oo-doo-nuh" },
  { english: "oven", sinhala: "උදුන", pronunciation: "oo-doo-nuh" },
  { english: "mirror", sinhala: "කණ්ණාඩිය", pronunciation: "kuhn-naa-dee-yuh" },
  { english: "clock", sinhala: "ඔරලෝසුව", pronunciation: "oh-ruh-loh-soo-vuh" },
  { english: "picture", sinhala: "පින්තූරය", pronunciation: "pin-thoo-ruh-yuh" },
  { english: "photo", sinhala: "ඡායාරූපය", pronunciation: "chaa-yaa-roo-puh-yuh" },
  { english: "carpet", sinhala: "කාපට්", pronunciation: "kaa-puht" },
  { english: "curtain", sinhala: "තිරය", pronunciation: "thee-ruh-yuh" },
  { english: "pillow", sinhala: "කොට්ටය", pronunciation: "koht-tuh-yuh" },
  { english: "blanket", sinhala: "බ්ලැන්කට්", pronunciation: "blehn-kuht" },
  { english: "towel", sinhala: "තුවාය", pronunciation: "thoo-vaa-yuh" },
  { english: "soap", sinhala: "සබන්", pronunciation: "suh-buhn" },
  { english: "toothbrush", sinhala: "දත් බුරුසුව", pronunciation: "duhth boo-roo-soo-vuh" },
  { english: "comb", sinhala: "පනාව", pronunciation: "puh-naa-vuh" },
  { english: "scissors", sinhala: "කතුර", pronunciation: "kuh-thoo-ruh" },
  { english: "knife", sinhala: "පිහිය", pronunciation: "pee-hee-yuh" },
  { english: "fork", sinhala: "ගෑරප්පුව", pronunciation: "geh-ruhp-poo-vuh" },
  { english: "spoon", sinhala: "හැන්ද", pronunciation: "hehn-duh" },
  { english: "plate", sinhala: "පිඟානය", pronunciation: "pin-gaa-nuh-yuh" },
  { english: "bowl", sinhala: "බඳුන", pronunciation: "buhn-doo-nuh" },
  { english: "cup", sinhala: "කෝප්පය", pronunciation: "kohp-puh-yuh" },
  { english: "bottle", sinhala: "බෝතලය", pronunciation: "boh-thuh-luh-yuh" },
  { english: "bucket", sinhala: "බාල්දිය", pronunciation: "baal-dee-yuh" },
  { english: "basket", sinhala: "කූඩය", pronunciation: "koo-duh-yuh" },
  { english: "box", sinhala: "පෙට්ටිය", pronunciation: "peht-tee-yuh" },
  { english: "rope", sinhala: "කඹය", pronunciation: "kuhm-buh-yuh" },
  { english: "hammer", sinhala: "මිටිය", pronunciation: "mee-tee-yuh" },
  
  // Sports & Games
  { english: "football", sinhala: "පාපන්දු", pronunciation: "paa-puhn-doo" },
  { english: "cricket", sinhala: "ක්‍රිකට්", pronunciation: "kree-kuht" },
  { english: "basketball", sinhala: "පැසිපන්දු", pronunciation: "peh-see-puhn-doo" },
  { english: "tennis", sinhala: "ටෙනිස්", pronunciation: "teh-nis" },
  { english: "swimming", sinhala: "පිහිනීම", pronunciation: "pee-hee-nee-muh" },
  { english: "running", sinhala: "දිවීම", pronunciation: "dee-vee-muh" },
  { english: "game", sinhala: "ක්‍රීඩාව", pronunciation: "kree-daa-vuh" },
  { english: "ball", sinhala: "පන්දුව", pronunciation: "puhn-doo-vuh" },
  { english: "team", sinhala: "කණ්ඩායම", pronunciation: "kuhn-daa-yuh-muh" },
  { english: "player", sinhala: "ක්‍රීඩකයා", pronunciation: "kree-duh-kuh-yaa" },
  
  // Education
  { english: "lesson", sinhala: "පාඩම", pronunciation: "paa-duh-muh" },
  { english: "class", sinhala: "පන්තිය", pronunciation: "puhn-thee-yuh" },
  { english: "exam", sinhala: "විභාගය", pronunciation: "vee-bhaa-guh-yuh" },
  { english: "test", sinhala: "පරීක්ෂණය", pronunciation: "puh-reek-shuh-nuh-yuh" },
  { english: "homework", sinhala: "ගෙදර වැඩ", pronunciation: "geh-duh-ruh veh-duh" },
  { english: "pencil", sinhala: "පැන්සල", pronunciation: "pehn-suh-luh" },
  { english: "eraser", sinhala: "මකනය", pronunciation: "muh-kuh-nuh-yuh" },
  { english: "ruler", sinhala: "රූලරය", pronunciation: "roo-luh-ruh-yuh" },
  { english: "notebook", sinhala: "සටහන් පොත", pronunciation: "suh-tuh-huhn poh-thuh" },
  { english: "dictionary", sinhala: "ශබ්දකෝෂය", pronunciation: "shuhb-duh-koh-shuh-yuh" },
  
  // Emotions & Feelings
  { english: "happiness", sinhala: "සතුට", pronunciation: "suh-thoo-tuh" },
  { english: "sadness", sinhala: "දුක", pronunciation: "doo-kuh" },
  { english: "anger", sinhala: "කෝපය", pronunciation: "koh-puh-yuh" },
  { english: "fear", sinhala: "බිය", pronunciation: "bee-yuh" },
  { english: "surprise", sinhala: "පුදුම", pronunciation: "poo-doo-muh" },
  { english: "hope", sinhala: "බලාපොරොත්තුව", pronunciation: "buh-laa-poh-rohth-thoo-vuh" },
  { english: "peace", sinhala: "සාමය", pronunciation: "saa-muh-yuh" },
  { english: "joy", sinhala: "ප්‍රීතිය", pronunciation: "pree-thee-yuh" },
  { english: "pain", sinhala: "වේදනාව", pronunciation: "vay-duh-naa-vuh" },
  { english: "dream", sinhala: "සිහිනය", pronunciation: "see-hee-nuh-yuh" },
  
  // Abstract Concepts
  { english: "life", sinhala: "ජීවිතය", pronunciation: "jee-vee-thuh-yuh" },
  { english: "death", sinhala: "මරණය", pronunciation: "muh-ruh-nuh-yuh" },
  { english: "time", sinhala: "කාලය", pronunciation: "kaa-luh-yuh" },
  { english: "money", sinhala: "මුදල්", pronunciation: "moo-duhl" },
  { english: "work", sinhala: "වැඩ", pronunciation: "veh-duh" },
  { english: "job", sinhala: "රැකියාව", pronunciation: "reh-kee-yaa-vuh" },
  { english: "problem", sinhala: "ප්‍රශ්නය", pronunciation: "pruhsh-nuh-yuh" },
  { english: "answer", sinhala: "පිළිතුර", pronunciation: "pee-lee-thoo-ruh" },
  { english: "question", sinhala: "ප්‍රශ්නය", pronunciation: "pruhsh-nuh-yuh" },
  { english: "idea", sinhala: "අදහස", pronunciation: "uh-duh-huh-suh" },
  { english: "reason", sinhala: "හේතුව", pronunciation: "hay-thoo-vuh" },
  { english: "way", sinhala: "මාර්ගය", pronunciation: "maar-guh-yuh" },
  { english: "place", sinhala: "තැන", pronunciation: "theh-nuh" },
  { english: "thing", sinhala: "දෙය", pronunciation: "deh-yuh" },
  { english: "person", sinhala: "පුද්ගලයා", pronunciation: "pood-guh-luh-yaa" },
  { english: "people", sinhala: "මිනිසුන්", pronunciation: "mee-nee-soon" },
  { english: "man", sinhala: "මිනිසා", pronunciation: "mee-nee-saa" },
  { english: "woman", sinhala: "කාන්තාව", pronunciation: "kaan-thaa-vuh" },
  { english: "boy", sinhala: "පිරිමි ළමයා", pronunciation: "pee-ree-mee luh-muh-yaa" },
  { english: "girl", sinhala: "ගැහැණු ළමයා", pronunciation: "geh-heh-noo luh-muh-yaa" },
  { english: "friend", sinhala: "යාළුවා", pronunciation: "yaa-loo-vaa" },
  { english: "enemy", sinhala: "සතුරා", pronunciation: "suh-thoo-raa" },
  { english: "neighbor", sinhala: "අසල්වැසියා", pronunciation: "uh-suhl-veh-see-yaa" },
  { english: "guest", sinhala: "අමුත්තා", pronunciation: "uh-mooth-thaa" },
  { english: "king", sinhala: "රජු", pronunciation: "ruh-joo" },
  { english: "queen", sinhala: "බිසව", pronunciation: "bee-suh-vuh" },
  { english: "god", sinhala: "දෙවියන්", pronunciation: "deh-vee-yuhn" },
  { english: "religion", sinhala: "ආගම", pronunciation: "aa-guh-muh" },
  { english: "language", sinhala: "භාෂාව", pronunciation: "bhaa-shaa-vuh" },
  { english: "word", sinhala: "වචනය", pronunciation: "vuh-chuh-nuh-yuh" },
  { english: "sentence", sinhala: "වාක්‍යය", pronunciation: "vaak-yuh-yuh" },
  { english: "letter", sinhala: "අකුර", pronunciation: "uh-koo-ruh" },
  { english: "story", sinhala: "කතාව", pronunciation: "kuh-thaa-vuh" },
  { english: "song", sinhala: "ගීතය", pronunciation: "gee-thuh-yuh" },
  { english: "music", sinhala: "සංගීතය", pronunciation: "suhn-gee-thuh-yuh" },
  { english: "art", sinhala: "කලාව", pronunciation: "kuh-laa-vuh" },
  { english: "science", sinhala: "විද්‍යාව", pronunciation: "vid-yaa-vuh" },
  { english: "history", sinhala: "ඉතිහාසය", pronunciation: "ee-thee-haa-suh-yuh" },
  { english: "future", sinhala: "අනාගතය", pronunciation: "uh-naa-guh-thuh-yuh" },
  { english: "past", sinhala: "අතීතය", pronunciation: "uh-thee-thuh-yuh" },
  { english: "present", sinhala: "වර්තමානය", pronunciation: "vuhr-thuh-maa-nuh-yuh" },
];

const Translator = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isPlaying, setIsPlaying] = useState(false);

  const searchResults = useMemo(() => {
    if (!searchTerm.trim()) return [];
    
    const term = searchTerm.toLowerCase().trim();
    
    // Exact match first
    const exactMatch = dictionary.filter(item => 
      item.english.toLowerCase() === term
    );
    
    // Then partial matches
    const partialMatches = dictionary.filter(item => 
      item.english.toLowerCase().includes(term) && 
      item.english.toLowerCase() !== term
    );
    
    return [...exactMatch, ...partialMatches].slice(0, 10);
  }, [searchTerm]);

  const handleSpeak = async (text) => {
    if (isPlaying) {
      soundService.stop();
      setIsPlaying(false);
      return;
    }

    setIsPlaying(true);
    try {
      await soundService.speakSinhalaWord(text);
    } catch (error) {
      console.error('Audio playback error:', error);
    } finally {
      setIsPlaying(false);
    }
  };

  return (
    <div className="translator-container">
      <div className="translator-header">
        <h2>🔍 English to Sinhala Translator</h2>
        <p>ඉංග්‍රීසි සිට සිංහල පරිවර්තකය</p>
      </div>
      
      <div className="translator-search">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Enter an English word..."
          className="translator-input"
          autoFocus
        />
        {searchTerm && (
          <button 
            className="clear-btn"
            onClick={() => setSearchTerm('')}
          >
            ✕
          </button>
        )}
      </div>

      <div className="translator-results">
        {searchTerm && searchResults.length === 0 && (
          <div className="no-results">
            <p>No translation found for "{searchTerm}"</p>
            <p className="hint">Try a different word or check spelling</p>
          </div>
        )}
        
        {searchResults.map((result, index) => (
          <div key={index} className="translation-card">
            <div className="translation-english">
              <span className="label">English:</span>
              <span className="word">{result.english}</span>
            </div>
            <div className="translation-sinhala">
              <span className="label">සිංහල:</span>
              <span className="word sinhala-text">{result.sinhala}</span>
            </div>
            <div className="translation-pronunciation">
              <span className="label">Pronunciation:</span>
              <span className="pronunciation">{result.pronunciation}</span>
            </div>
            <button
              className={`speak-btn ${isPlaying ? 'playing' : ''}`}
              onClick={() => handleSpeak(result.sinhala)}
            >
              {isPlaying ? '⏹️ Stop' : '🔊 Listen'}
            </button>
          </div>
        ))}
      </div>

      {!searchTerm && (
        <div className="translator-hint">
          <p>💡 Type an English word above to see its Sinhala translation</p>
          <p>Try: hello, mother, water, school, thank you</p>
        </div>
      )}

      <style jsx>{`
        .translator-container {
          max-width: 600px;
          margin: 0 auto;
          padding: 20px;
        }
        
        .translator-header {
          text-align: center;
          margin-bottom: 30px;
        }
        
        .translator-header h2 {
          color: #667eea;
          margin-bottom: 5px;
        }
        
        .translator-header p {
          color: #888;
          font-size: 1.1em;
        }
        
        .translator-search {
          position: relative;
          margin-bottom: 20px;
        }
        
        .translator-input {
          width: 100%;
          padding: 15px 45px 15px 20px;
          font-size: 1.2em;
          border: 2px solid #e0e0e0;
          border-radius: 12px;
          outline: none;
          transition: border-color 0.3s;
        }
        
        .translator-input:focus {
          border-color: #667eea;
        }
        
        .clear-btn {
          position: absolute;
          right: 15px;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          font-size: 1.2em;
          color: #888;
          cursor: pointer;
        }
        
        .clear-btn:hover {
          color: #333;
        }
        
        .translator-results {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }
        
        .translation-card {
          background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
          border-radius: 12px;
          padding: 20px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }
        
        .translation-english,
        .translation-sinhala,
        .translation-pronunciation {
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        
        .label {
          font-size: 0.85em;
          color: #666;
          min-width: 100px;
        }
        
        .word {
          font-size: 1.3em;
          font-weight: 600;
          color: #333;
        }
        
        .sinhala-text {
          font-size: 1.5em;
          color: #667eea;
        }
        
        .pronunciation {
          font-style: italic;
          color: #888;
          font-size: 1.1em;
        }
        
        .speak-btn {
          width: 100%;
          padding: 12px;
          margin-top: 10px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 1.1em;
          cursor: pointer;
          transition: transform 0.2s, box-shadow 0.2s;
        }
        
        .speak-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
        }
        
        .speak-btn.playing {
          background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
        }
        
        .no-results {
          text-align: center;
          padding: 30px;
          color: #666;
        }
        
        .no-results .hint {
          font-size: 0.9em;
          color: #888;
          margin-top: 10px;
        }
        
        .translator-hint {
          text-align: center;
          padding: 40px 20px;
          color: #666;
          background: #f9f9f9;
          border-radius: 12px;
        }
        
        .translator-hint p:first-child {
          font-size: 1.1em;
          margin-bottom: 10px;
        }
        
        .translator-hint p:last-child {
          color: #888;
          font-size: 0.95em;
        }
      `}</style>
    </div>
  );
};

export default Translator;
